import { useTranslation } from "react-i18next";
import { Activity, Bot, Trophy, ShieldCheck, TrendingUp, Flame, LineChart, Bell, Building2 } from "lucide-react";

const ICONS = [Activity, Bot, Trophy, ShieldCheck, TrendingUp, Flame, LineChart, Bell, Building2];

export default function IncludedFeatures() {
  const { t } = useTranslation("products");
  const items = t("sts.pricing.included.items", { returnObjects: true });
  return (
    <div data-testid="sts-included-features" className="mt-16 max-w-5xl mx-auto rounded-3xl border border-slate-200 bg-white p-8 md:p-10">
      <div className="text-center max-w-xl mx-auto">
        <p className="text-[12px] uppercase tracking-[0.18em] text-slate-500">{t("sts.pricing.included.eyebrow")}</p>
        <h3 className="font-display mt-2 text-[26px] md:text-[32px] text-[#0A1128] leading-tight">
          {t("sts.pricing.included.title")}
        </h3>
      </div>
      <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((f, i) => {
          const Icon = ICONS[i];
          return (
            <div key={f.title} className="flex items-start gap-3">
              <div className="inline-flex items-center justify-center h-8 w-8 rounded-lg bg-[#00C48C]/10 text-[#008466] shrink-0">
                <Icon className="h-4 w-4" />
              </div>
              <div>
                <p className="font-display text-[15px] text-[#0A1128]">{f.title}</p>
                <p className="mt-1 text-[12.5px] text-slate-600 leading-relaxed">{f.body}</p>
              </div>
            </div>
          );
        })}
      </div>
      <p data-testid="sts-pricing-footnote" className="mt-8 text-center text-[12px] text-slate-500">
        {t("sts.pricing.included.footnote")}
      </p>
    </div>
  );
}
